import { FunctionComponent, h } from 'preact'
import { useContext } from 'preact/hooks'
import { CSSProperties } from 'preact/compat'
import cls from 'classnames'

import BaseContext from 'contexts/base-context'
import { defaultButtonStyle, defaultColorScheme, defaultTextStyle } from 'scripts/constants'
import { getRootStyle, getUrlParam } from 'scripts/utils'

import CloseBtn from './CloseBtn'
import ProgressBar from './ProgressBar'

import classes from './index.module.scss'

type Props = {
  style?: CSSProperties
  onClose?: () => void
  closeStyle?: CSSProperties
  type: 'survey' | 'feedback' | 'reply'
}

const FormContainer: FunctionComponent<Props> = (props) => {
  const { onClose, children, type, style = '', closeStyle = {} } = props
  const { interactive, isPreview, formSetting: setting, isUrlVisit } = useContext(BaseContext)
  const closeable = (getUrlParam('closeable') === '1' || isPreview) && interactive && !isUrlVisit && type !== 'reply'

  const rootStyle = getRootStyle({
    colorScheme: setting?.colorScheme ?? defaultColorScheme,
    buttonStyle: setting?.buttonStyle ?? defaultButtonStyle,
    textStyle: setting?.textStyle ?? defaultTextStyle,
  })

  const showProgress = setting?.showProgressBar

  const direction = (setting?.textStyle?.direction?.toLowerCase() ?? 'ltr') as 'ltr' | 'rtl'

  return (
    <div
      dir={direction}
      className={cls(classes.fieldContainer, classes[type!], { [classes.pageContainer]: isUrlVisit })}
      style={`${rootStyle} ${style}`}
    >
      {showProgress && <ProgressBar />}
      {closeable && <CloseBtn className={interactive ? '' : classes.readOnly} onClose={onClose} style={closeStyle} />}
      {children}
    </div>
  )
}

export default FormContainer
